module.exports = __webpack_public_path__ + "img/white-smoke.06ccccb4.png";